module.exports = __webpack_public_path__ + "img/Clear_Filled_12px_Icon-dark.ca374e23.svg";